import fp from 'lodash/fp';
import React from 'react';
import he from 'he';

export const getInitials = (name) => fp.flow(
  fp.map(fp.first),
  fp.map(fp.toUpper),
  initials => initials.slice(0, 2),
  initials => initials.join('')
)(name.split(' '))

export const TeamAvatar = ({ teamName }) => <span className='team-avatar'>
  {getInitials(teamName)}
</span>

export const UserAvatar = ({ userName, className, avatar }) =>
  avatar ?
    <img className='user-avatar' alt={getInitials(userName)} src={he.decode(avatar)} />
    :
    <span className={'user-avatar avatar-initials ' + className}>
      {getInitials(userName)}
    </span> 


// WEBPACK FOOTER //
// ./src/containers/components/avatar.js